import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "runtime-import" }
const _hoisted_2 = ["disabled"]

import { ref } from "vue";
import { toast } from "vue-sonner";

export default /*@__PURE__*/_defineComponent({
  __name: 'RuntimeImportButton',
  props: {
    disabled: { type: Boolean },
    importFile: { type: Function }
  },
  setup(__props: any) {

const props = __props;
const input = ref<HTMLInputElement>();
const pending = ref(false);
async function change(event: Event) {
  const element = event.target as HTMLInputElement;
  const file = element.files?.[0]; element.value = "";
  if (!file || pending.value || props.disabled) return;
  pending.value = true;
  try { await props.importFile(file); }
  catch (error) { toast.error(error instanceof Error ? error.message : "导入失败，原配置未替换"); }
  finally { pending.value = false; }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("input", {
      ref_key: "input",
      ref: input,
      type: "file",
      accept: ".json,application/json",
      "aria-label": "选择千星运行时配置",
      hidden: "",
      onChange: change
    }, null, 544),
    _createElementVNode("button", {
      type: "button",
      disabled: __props.disabled || pending.value,
      title: "导入千星编辑器导出的运行时 JSON",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (input.value?.click()))
    }, _toDisplayString(pending.value ? '导入中…' : '导入配置'), 9, _hoisted_2)
  ]))
}
}

})